import { Navigate } from 'react-router-dom';
import { IRoute, PortalRoutePath } from '@models';
import { Tr } from '@utils';
import { Permission } from '@services';
// import { DailyTasksIcon } from '@components/icons';
import { DailyTasksLanding } from './DailyTasksLanding';
// import { DailyTasksResult } from './DailyTasksResult';
// import { ElectrificationSelectVehicles } from './ElectrificationSelectVehicles';
// import { DailyTasksProcessing } from './DailyTasksProcessing';
import { DailyTasksStart } from './DailyTasksStart';
import { DailyTasksProcessing } from './DailyTasksProcessing';
import { DailyTasksResult } from './DailyTasksResult/DailyTasksResult';

export const DAILYTASKS_ROUTES: IRoute = {
	path: PortalRoutePath.DAILYTASKS,
	// icon: <DailyTasksIcon />,
	// text: <Tr.Portal path="DailyTasks.title" />,
	// text: 'text to be replaced',
	hideFromMenu: true,
	// canActivate: (_route, user) => !!user?.hasPermission([Permission.DAILYTASKS_READ, Permission.DAILYTASKS_WRITE]),
	children: [
		{
			path: '',
			element: <DailyTasksLanding />
		},
		{
			path: 'start',
			element: <DailyTasksStart />
		},
		{
			path: 'processing',
			element: <DailyTasksProcessing />
		},
		{
			path: 'result',
			element: <DailyTasksResult />
		},
		// {
		// 	path: 'select-vehicles',
		// 	element: <ElectrificationSelectVehicles />
		// },
		{
			index: true,
			path: '*',
			hideFromMenu: true,
			element: <Navigate to={{ pathname: '/portal' }} replace />
		}
	]
};
